import styled, { css } from "styled-components";
import { buildColor, breakpoints } from "@tvg/design-system";

const commonModulesStyle = css`
  display: flex;
  flex-direction: column;
`;

export const MainContainer = styled.div<{
  isMobile?: boolean;
  isReplayModal?: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: ${buildColor("blue", "000")};
  padding: ${({ isReplayModal = false, theme }) =>
    isReplayModal ? 0 : theme.space["space-4"]};

  @media screen and ${breakpoints.tablet.max.sm} {
    padding: 0;
  }

  ${({ isMobile }) =>
    isMobile &&
    css`
      padding: 0;
    `}
`;

export const MainWrapper = styled.div`
  display: flex;
  ${(props: { shouldBreakLegs: boolean }) =>
    props.shouldBreakLegs && "flex-direction: column;"}

  @media screen and ${breakpoints.tablet.max.sm} {
    flex: 1;
    flex-direction: column;
  }
`;

export const RaceCardContainer = styled.div`
  height: fit-content;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  background-color: ${buildColor("white", "900")};
  border-radius: 4px;
  border: 1px solid ${buildColor("blue", "100")};
  overflow: hidden;
`;

export const AuxiliaryModulesContainer = styled.div`
  ${commonModulesStyle};
  width: 325px;
  ${(props: { shouldBreakLegs: boolean }) =>
    props.shouldBreakLegs &&
    css`
      width: 100%;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: auto 1fr;
      column-gap: 1.25%;
    `}

  @media screen and ${breakpoints.tablet.max.sm} {
    width: 100%;
  }
`;

export const PrimaryModulesContainer = styled.div<{
  shouldBreakLegs: boolean;
  isPicksView?: boolean;
  isReplayModal?: boolean;
}>`
  ${commonModulesStyle};
  ${({ shouldBreakLegs, isReplayModal = false }) =>
    !shouldBreakLegs && !isReplayModal && "margin-right: 10px;"}
  overflow: hidden;
  flex: 1;

  @media screen and ${breakpoints.tablet.max.sm} {
    margin-right: 0;

    & > div {
      margin-top: ${({ isReplayModal = false }) =>
        isReplayModal ? 0 : "12px"};
      border-left: 0 none;
      border-right: 0 none;
      ${({ isPicksView }) =>
        isPicksView &&
        css`
          border: 0 none;
          margin-bottom: 0;
        `}
    }
  }
`;

export const AlertInlineContainer = styled.div`
  display: flex;
  flex-direction: column;

  div[data-qa-label="state-blocked-error"] {
    border-top-width: 0;
  }
`;

export const Divider = styled.hr`
  width: 100%;
  border-top: 1px solid ${buildColor("blue", "100")};
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: auto;
  margin-inline-end: auto;
  border-top-style: none;
  border-top-width: 0;
`;
